export default "__VITE_ASSET__DKzEBpqI__"